import { twMerge } from 'tailwind-merge';

import { useConfigStore } from '@packages/stores';

import { Text } from '@elements/text';
import { i18n } from '@i18n';

export const EmcNeedHelp = (props: { className?: string }) => {
  const customerServiceNumber = useConfigStore(
    state => state.regionSpecificConfig?.CUSTOMER_SERVICE_NUMBER,
  );
  const customerServiceNumberLink = customerServiceNumber?.replace(/\s+/g, '');

  return (
    <span className={twMerge('flex', props.className)}>
      <Text variant="body-16/sb">{i18n.t('emcShared.global.contact.web')} </Text>
      <a
        href={'tel:' + customerServiceNumberLink}
        className="text-cabo-700 ml-s4 hover:text-opacity-80 font-semibold">
        {customerServiceNumber}
      </a>
    </span>
  );
};
